import HTTPClient from './http-client';

const options = {
  cache: {
    maxAge: 15 * 60 * 1000,
    exclude: { query: false }
  }
}

const END_POINT = '/infohidro/fmac.json';

const loadFmac = async () => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}`,
    options
  );
}

export {
  loadFmac
}
